import AdminDashboard from "../pages/Admin/Dashboard/AdminDashboard";

import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import Profile from "../pages/Admin/Profile/Profile";
import Color from "../pages/Admin/Colors/Colors";
import Transmission from "../pages/Admin/Transmissions/Transmissions";
import Feature from "../pages/Admin/Features/Features";
import Fuel from "../pages/Admin/Fuels/Fuels";
import Country from "../pages/Admin/Countries/Countries";
import VehicleType from "../pages/Admin/VehicleTypes/VehicleTypes";
import Make from "../pages/Admin/Makes/Makes";
import Model from "../pages/Admin/Models/Models";
import ModelCode from "../pages/Admin/ModelCodes/ModelCodes";
import Vehicle from "../pages/Admin/Vehicle/Vehicle";
import Vehicles from "../pages/Admin/Vehicles/Vehicles";
import VehicleEdit from "../pages/Admin/Vehicles/VehicleEdit/VehicleEdit";
import VehicleCostSheet from "../pages/Admin/Vehicles/VehicleCostSheet/VehicleCostSheet";
import Order from "../pages/Admin/Orders/Orders";
import Staff from "../pages/Admin/Staff/Staff";
import CustomerRequests from "../pages/Admin/CustomerRequests/CustomerRequests";
import CreateOrder from "../pages/Admin/Orders/CreateOrder/CreateOrder";
import ViewOrder from "../pages/Admin/Orders/Order/ViewOrder";
import Options from "../pages/Admin/Options/Options";
import ViewPayment from "../pages/Admin/Orders/Order/Payment/ViewPayment";
import InsertDocument from "../pages/Admin/Orders/Order/InsertDocument/InsertDocument";
import Customer from "../pages/Admin/Customers/Customer";
import CustomerLedger from "../pages/Admin/Customers/CustomerLedger/CustomerLedger";
import Banner from "../pages/Admin/Banners/Banner";
import Inquiries from "../pages/Admin/Inquiries/Inquiries";
import BannerCreate from "../pages/Admin/Banners/BannerCreate/BannerCreate";
import ViewInquiry from "../pages/Admin/Inquiries/ViewInquiry/ViewInquiry";
import NewCustomer from "../pages/Admin/Customers/NewCustomer/NewCustomer";
import VehicleInvoice from "../pages/Admin/InvoiceVehicle/VehicleInvoice";
import BankAccounts from "../pages/Admin/BankAccounts/BankAccounts";
import QuickInvoices from "../pages/Admin/QuickInvoices/QuickInvoices";
import QuickInvoice from "../pages/Admin/QuickInvoices/QuickInvoice/QuickInvoice";
import EditQuickInvoice from "../pages/Admin/QuickInvoices/EditQuickInvoice/EditQuickInvoice";

var AdminRoutes = [
  {
    path: "dashboard",
    name: "Dashboard",
    element: <AdminDashboard />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "quick-invoices",
    name: "Quick Invoices",
    element: <QuickInvoices />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "vehicle",
    name: "Add Vehicle",
    element: <Vehicle />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "vehicles",
    name: "Vehicles",
    element: <Vehicles />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "orders",
    name: "Orders",
    element: <Order />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "invoice-vehicle",
    name: "Invoice Vehicle",
    element: <VehicleInvoice />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "requests",
    name: "Customer Requests",
    element: <CustomerRequests />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "staff",
    name: "Staff Members",
    element: <Staff />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "customer",
    name: "Customers",
    element: <Customer />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "banner",
    name: "Banners",
    element: <Banner />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "inquiries",
    name: "Inquiries",
    element: <Inquiries />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "accounts",
    name: "Accounts",
    element: <BankAccounts />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "options",
    name: "Options",
    element: <Options />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "vehicles/:id",
    name: "Vehicle Edit",
    element: <VehicleEdit />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "vehicles/:id&cost",
    name: "Vehicle Cost Sheet",
    element: <VehicleCostSheet />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "orders/create-order",
    name: "New Order",
    element: <CreateOrder />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "orders/:id",
    name: "Order",
    element: <ViewOrder />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "orders/:id/document",
    name: "Document",
    element: <InsertDocument />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "orders/:orderId/:id",
    name: "Payment",
    element: <ViewPayment />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "colors",
    name: "Colors",
    element: <Color />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "transmissions",
    name: "Transmissions",
    element: <Transmission />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "features",
    name: "Features",
    element: <Feature />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "fuels",
    name: "Fuel Types",
    element: <Fuel />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "countries",
    name: "Countries",
    element: <Country />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "vehicle-types",
    name: "Vehicle Types",
    element: <VehicleType />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "makes",
    name: "Makes",
    element: <Make />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "models",
    name: "Models",
    element: <Model />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "model-codes",
    name: "Model Codes",
    element: <ModelCode />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "profile",
    name: "Profile",
    element: <Profile />,
    layout: 'admin',
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon
  },
  {
    path: "customer/ledger/:id",
    name: "Customer Ledger",
    element: <CustomerLedger />,
    layout: 'admin',
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon
  },
  {
    path: "banner/create-banner",
    name: "Create Banner",
    element: <BannerCreate />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "inquiries/:id",
    name: "Inquiry",
    element: <ViewInquiry />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "customer/create-customer",
    name: "New Customer",
    element: <NewCustomer />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "quick-invoices/create-quick-invoice",
    name: "Quick Invoice",
    element: <QuickInvoice />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "quick-invoices/:id",
    name: "Edit Quick Invoice",
    element: <EditQuickInvoice />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default AdminRoutes;
